import { ContentCopy } from '@mui/icons-material';
import { IconButton, SxProps, Theme, Tooltip } from '@mui/material';
import { type MouseEvent as ReactMouseEvent, useState } from 'react';

import { copyToClipboard } from '../../utils';

const tooltips = {
  COPY: 'Klicken zum Kopieren',
  SUCCESS: 'Kopiert',
};

type CopyProps = {
  readonly text: string;
  readonly showOnTooltip?: boolean;
  readonly buttonStyles?: SxProps<Theme>;
};

export const CopyButton = ({ text, showOnTooltip = false, buttonStyles = {} }: CopyProps) => {
  const [tooltipTitle, setTooltipTitle] = useState(showOnTooltip ? '' : tooltips.COPY);

  const handleClick = (event: ReactMouseEvent): void => {
    event.stopPropagation();
    void copyToClipboard(text);
    setTooltipTitle(tooltips.SUCCESS);
  };

  const handleOpen = (): void => {
    if (showOnTooltip) {
      setTooltipTitle('');
    } else {
      setTooltipTitle(tooltips.COPY);
    }
  };
  return (
    <Tooltip title={tooltipTitle} onOpen={handleOpen}>
      <IconButton
        onClick={handleClick}
        sx={[
          {
            color: (theme) => (showOnTooltip ? theme.palette.text.primaryOnBrand : theme.palette.text.primary),
          },
          ...[buttonStyles].flat(),
        ]}
      >
        <ContentCopy sx={{ fontSize: '1rem' }} />
      </IconButton>
    </Tooltip>
  );
};
